<template>
  <div v-if="isVisible" class="fixed inset-0 bg-gray-600 bg-opacity-70 z-50 flex justify-center items-center p-4">
    <div class="bg-white dark:bg-gray-900 p-6 rounded-lg w-full max-w-6xl">
      <h2 class="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">Job History #{{ jobId }}</h2>

      <div class="overflow-auto max-h-[60vh] border border-gray-300 dark:border-gray-700 rounded">
        <table class="min-w-full text-xs">
          <thead class="sticky top-0">
            <tr class="bg-gray-200 dark:bg-gray-800 text-gray-700 dark:text-gray-100">
              <th class="py-2 px-3 border dark:border-gray-700 bg-gray-200 dark:bg-gray-800">Action By</th>
              <th class="py-2 px-3 border dark:border-gray-700 bg-gray-200 dark:bg-gray-800">Action</th>
              <th class="py-2 px-3 border dark:border-gray-700 bg-gray-200 dark:bg-gray-800">Description</th>
              <th class="py-2 px-3 border dark:border-gray-700 bg-gray-200 dark:bg-gray-800">Original Time</th>
              <th class="py-2 px-3 border dark:border-gray-700 bg-gray-200 dark:bg-gray-800">New Time</th>
              <th class="py-2 px-3 border dark:border-gray-700 bg-gray-200 dark:bg-gray-800">Timestamp</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="entry in history" :key="entry.ts" class="border-t border-gray-200 dark:border-gray-700 text-gray-800 dark:text-gray-100">
              <td class="py-2 px-3">{{ entry.actionby }}</td>
              <td class="py-2 px-3">{{ entry.action }}</td>
              <td class="py-2 px-3">
                <div v-if="hideDescription" class="italic text-red-500 text-sm">PRIVATE</div>
                <div v-else :ref="`viewer-${entry.ts}`"></div>
              </td>
              <td class="py-2 px-3">{{ formatTime(entry.originaltime) }}</td>
              <td class="py-2 px-3">{{ formatTime(entry.newtime) }}</td>
              <td class="py-2 px-3">{{ entry.ts }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex justify-end space-x-2 mt-4">
        <button @click="closeModal" class="bg-gray-400 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded dark:bg-red-500 dark:hover:bg-red-700">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import '@toast-ui/editor/dist/theme/toastui-editor-dark.css';

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    hideDescription: {
      type: Boolean,
      required: false,
      default: false
    },
    jobId: {
      type: [String, Number],
      required: true,
    },
    history: {
      type: Array,
      required: true,
    },
  },
  watch: {
    history() {
      this.$nextTick(() => {
        this.initViewers();
      });
    },
    isVisible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.initViewers();
        });
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    formatTime(value) {
      const num = parseFloat(value);
      if (!isNaN(num)) {
        return num.toFixed(2);
      }
      return value || '-';
    },
    fixMarkdownIndentation(text) {
      return text
        .split('\n')
        .map(line => {
          // Fix indentation for list items that start with ' - '
          if (line.startsWith(' - ')) {
            line = '    - ' + line.slice(3);
          }

          // Fix markdown headings without space, e.g., '###Heading' → '### Heading'
          line = line.replace(/^(#{1,6})([^\s#])/g, '$1 $2');

          return line;
        })
        .join('\n');
    },
    initViewers() {
      this.history.forEach(entry => {
        const el = this.$refs[`viewer-${entry.ts}`];
        if (el && (Array.isArray(el) ? el[0] : el)) {
          new Viewer({
            el: Array.isArray(el) ? el[0] : el,
            initialValue: this.fixMarkdownIndentation(entry.description || ''),
            theme: document.documentElement.classList.contains('dark') ? 'dark' : 'default',
          });
        }
      });
    },
  },
};
</script>

<style scoped>
/* Optional fine-tuning */
th, td {
  vertical-align: top;
}
</style>
